import type { TableColumnsType } from 'ant-design-vue'

// 字节渠道列表
export const FILTER_CHANNEL_LIST = ['douyingame', 'douyinOrdinaryMiniGame', 'jsapipay', 'wxminigame', 'wxminigame_ios']

export const columns: TableColumnsType = [
  {
    title: '产品ID',
    key: 'dbtId',
    dataIndex: 'dbtId',
    width: 52,
  },
  {
    title: '产品名称',
    key: 'appName',
    dataIndex: 'appName',
  },
]
